module.exports = __webpack_public_path__ + "files/076a9b92f499cc2c4c78b93491e09980.png";